// Sentry initialization for the frontend bundle.
//
// Phase 5: error reporting. Sentry catches unhandled JS errors, unhandled
// promise rejections, and React render-time crashes, ships them to the
// Sentry dashboard with stack traces + breadcrumbs.
//
// Init runs ONCE at module load (when main.jsx imports this file). The
// SDK gracefully no-ops if VITE_SENTRY_DSN is empty — useful for local
// dev where we don't want noise from work-in-progress code.

import * as Sentry from '@sentry/react';

const dsn = (import.meta.env.VITE_SENTRY_DSN || '').trim();
const environment = (import.meta.env.VITE_SENTRY_ENVIRONMENT || 'unknown').trim();

if (dsn) {
  Sentry.init({
    dsn,
    environment,
    // Quiet by default — only ship actual errors. We're not paying for
    // performance traces or session replay on the free tier.
    tracesSampleRate: 0,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 0,
    // Drop the noisy ResizeObserver loop warnings that Chrome fires on
    // tab switches — they're harmless and would flood the dashboard.
    ignoreErrors: [
      'ResizeObserver loop limit exceeded',
      'ResizeObserver loop completed with undelivered notifications',
    ],
  });
}

// Re-export so other modules import everything they need from one place.
export { Sentry };

// Helper: push (or clear) the current Clerk user as the Sentry user
// context. Called from AuthContext when sign-in / sign-out happens so
// every error report is tagged with WHO hit it.
export function setSentryUser(user) {
  if (!dsn) return;
  if (user && user.id && user.email) {
    Sentry.setUser({ id: user.id, email: user.email });
  } else {
    Sentry.setUser(null);
  }
}
